export const STAKING_RISK_PRODUCTS_LIST = "STAKING_RISK_PRODUCTS_LIST";
export const CREATE_STAKING_RISK_PRODUCT_BYID_FOR_USER =
  "CREATE_STAKING_RISK_PRODUCT_BYID_FOR_USER";
export const STAKING_RISK_PRODUCTS_LIST_USER_INFO =
  "STAKING_RISK_PRODUCTS_LIST_USER_INFO";
export const DELETE_STAKING_RISK_PRODUCT_BYID_FOR_USER =
  "DELETE_STAKING_RISK_PRODUCT_BYID_FOR_USER";
export const GET_STAKING_RISK_PRODUCT_USERINFO =
  "GET_STAKING_RISK_PRODUCT_USERINFO";
export const CREATE_STAKING_RISK_PRODUCT_BYID_ERROR =
  "CREATE_STAKING_RISK_PRODUCT_BYID_ERROR";

export const UPDATE_STAKING_RISK_PRODUCT_USERINFO =
  "UPDATE_STAKING_RISK_PRODUCT_USERINFO";
export const STAKING_PORTFOLIO_RISK = "STAKING_PORTFOLIO_RISK";
export const UPDETE_STAKINGRISK_ALERT_SUCCESS =
  "UPDETE_STAKINGRISK_ALERT_SUCCESS";
export const STAKING_RISK_INVESTMENT_RISK_ALERT =
  "STAKING_RISK_INVESTMENT_RISK_ALERT";
export const STAKING_RISK_PRODUCTS_LIST_USER_INFO_WITH_NO_SELECTED =
  "STAKING_RISK_PRODUCTS_LIST_USER_INFO_WITH_NO_SELECTED";
export const CREATE_STAKING_RISK_PRODUCT_LOADING =
  "CREATE_STAKING_RISK_PRODUCT_LOADING";
const stakingRiskState = {
  error: null,
  loading: false,
  success: false,
  stakingRiskProductsList: [],
  stakingRiskProductsListWithNoSelected: [],
  stakingRiskProductInfo: [],
  stakingRiskProductsListUserInfo: [],
  userStakingProductCreatedByIDSuccess: false,
  userStakingProductDeletedByIDSuccess: false,
  userStakingProductUpdatedByIDSuccess: false,
  createProductError: false,
  stakingPortfolioRiskResult: [],
  updateStakingRiskInvestmentAlertSuccess: false,
  stakingRiskInvestmentRiskAlertResult: [],
};

export function StakingRiskReducer(state = stakingRiskState, action) {
  if (action.type === STAKING_RISK_PRODUCTS_LIST) {
    return {
      ...state,
      stakingRiskProductsList: action.payload.data,
      userStakingProductDeletedByIDSuccess: false,
      userStakingProductCreatedByIDSuccess: false,
    };
  } else if (
    action.type === STAKING_RISK_PRODUCTS_LIST_USER_INFO_WITH_NO_SELECTED
  ) {
    return {
      ...state,
      stakingRiskProductsListWithNoSelected: action.payload.data,
      userStakingProductDeletedByIDSuccess: false,
      userStakingProductCreatedByIDSuccess: false,
    };
  } else if (action.type === CREATE_STAKING_RISK_PRODUCT_LOADING) {
    return {
      ...state,
      loading: true,
      userStakingProductCreatedByIDSuccess: false,
      createProductError: false,
    };
  } else if (action.type === CREATE_STAKING_RISK_PRODUCT_BYID_FOR_USER) {
    return {
      ...state,
      loading: false,
      userStakingProductCreatedByIDSuccess: true,
      userStakingProductDeletedByIDSuccess: false,
      userStakingProductUpdatedByIDSuccess: false,
      createProductError: false,
    };
  } else if (action.type === CREATE_STAKING_RISK_PRODUCT_BYID_ERROR) {
    return {
      ...state,
      userStakingProductCreatedByIDSuccess: false,
      createProductError: action.payload,
    };
  } else if (action.type === STAKING_RISK_PRODUCTS_LIST_USER_INFO) {
    return {
      ...state,
      stakingRiskProductsListUserInfo: action.payload.data,
      userStakingProductDeletedByIDSuccess: false,
    };
  } else if (action.type === DELETE_STAKING_RISK_PRODUCT_BYID_FOR_USER) {
    return {
      ...state,
      userStakingProductDeletedByIDSuccess: true,
    };
  } else if (action.type === GET_STAKING_RISK_PRODUCT_USERINFO) {
    return {
      ...state,
      stakingRiskProductInfo: action.payload.data,
    };
  } else if (action.type === UPDATE_STAKING_RISK_PRODUCT_USERINFO) {
    return {
      ...state,
      userStakingProductUpdatedByIDSuccess: true,
      userStakingProductCreatedByIDSuccess: false,
      userStakingProductDeletedByIDSuccess: false,
    };
  } else if (action.type === STAKING_PORTFOLIO_RISK) {
    return {
      ...state,
      stakingPortfolioRiskResult: action.payload.result,
    };
  }
  if (action.type === UPDETE_STAKINGRISK_ALERT_SUCCESS) {
    return {
      ...state,
      updateStakingRiskInvestmentAlertSuccess: true,
    };
  }
  if (action.type === STAKING_RISK_INVESTMENT_RISK_ALERT) {
    return {
      ...state,
      stakingRiskInvestmentRiskAlertResult: action.payload.result,
    };
  }
  return state;
}
